var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8164 19C9.08582 19 7.3941 18.4868 5.95517 17.5254C4.51624 16.5639 3.39473 15.1973 2.73246 13.5985C2.0702 11.9996 1.89692 10.2403 2.23454 8.54296C2.57216 6.84563 3.40552 5.28653 4.62923 4.06282C5.85294 2.83911 7.41204 2.00575 9.10937 1.66813C10.8067 1.33051 12.566 1.50379 14.1649 2.16606C15.7637 2.82832 17.1303 3.94983 18.0918 5.38876C19.0532 6.82769 19.5664 8.51942 19.5664 10.25C19.5664 12.5706 18.6445 14.7962 17.0036 16.4372C15.3626 18.0781 13.1371 19 10.8164 19ZM10.8164 2.75C9.33305 2.75 7.883 3.18987 6.64963 4.01398C5.41627 4.83809 4.45497 6.00943 3.88731 7.37988C3.31966 8.75032 3.17113 10.2583 3.46052 11.7132C3.74991 13.168 4.46422 14.5044 5.51311 15.5533C6.562 16.6022 7.89838 17.3165 9.35323 17.6059C10.8081 17.8953 12.3161 17.7468 13.6865 17.1791C15.057 16.6114 16.2283 15.6501 17.0524 14.4168C17.8765 13.1834 18.3164 11.7334 18.3164 10.25C18.3164 8.26088 17.5262 6.35323 16.1197 4.9467C14.7132 3.54018 12.8055 2.75 10.8164 2.75Z",
    fill: "#100C41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6852 14L10.1914 10.5062V4.625H11.4414V9.9875L14.5664 13.1187L13.6852 14Z",
    fill: "#100C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonTime);
export default __webpack_public_path__ + "static/media/carbon_time.15de50afd9ca7b1240a5b5ed80a50dc3.svg";
export { ForwardRef as ReactComponent };